<template>
  <form-item label-width="80" labelAlign="left" label="字段别名">
    <el-input v-model="temData.indexAlias"/>
  </form-item>
  <form-item label-width="80" labelAlign="left" label="标题提示">
    <el-input v-model="temData.indexTip"/>
  </form-item>
  <form-item label-width="80" labelAlign="left" label="单位">
    <el-input v-model="temData.indexUnit"/>
  </form-item>
  <form-item label-width="80" labelAlign="left" label="分组标题">
    <el-input v-model="temData.columnGroupKey"/>
  </form-item>
  <form-item label-width="80" labelAlign="left" label="聚合方式" tip="">
    <el-radio-group class="mb-10" v-model="temData.plWay">
      <el-radio v-for="(item, index) in list" :key="item.index" :label="item.value">{{ item.name }}</el-radio>
    </el-radio-group>
  </form-item>
  <form-item label-width="80" labelAlign="left" label="排序方式">
    <el-radio-group class="mb-10" v-model="temData.orderWay">
      <el-radio label="noOrder">不排序</el-radio>
      <el-radio label="asc">升序</el-radio>
      <el-radio label="desc">降序</el-radio>
      <el-radio label="custom" v-if="item.fieldType === 'String'">自定义</el-radio>
    </el-radio-group>
  </form-item>
  <form-item v-if="temData.orderWay === 'custom'" label-width="80" labelAlign="left" label="自定义排序">
    <el-input type="textarea" autosize placeholder="如： 1班,2班,3班,4班,5班 内容以英文逗号分隔"
              v-model="temData.customOrder"/>
  </form-item>
  <form-item v-if="compType === 'mixBarNew'" label-width="80" labelAlign="left" label="柱线切换">
    <el-radio-group v-model="temData.seriesType">
      <el-radio label="">不处理</el-radio>
      <el-radio label="line" name="线">线</el-radio>
      <el-radio label="bar" name="柱">柱</el-radio>
    </el-radio-group>
  </form-item>
</template>
<script setup>
import {computed} from "vue";
import {MODEL_COLUMN_TYPE} from "@/option/common/dict.js";

let props = defineProps({
  option: {},
  temData: {},
  compType: {},
  item: {},
});
let list = computed(() => {
  let basic = [
    {
      name: "不聚合",
      value: "noPl",
    },
    {
      name: "计数",
      value: "count",
    },
    {
      name: "计数去重",
      value: "countDis",
    },
    {
      name: "最大值",
      value: "max",
    },
    {
      name: "最小值",
      value: "min",
    },
  ];
  let num = [
    {
      name: "求和",
      value: "sum",
    },
    {
      name: "平均值",
      value: "avg",
    },
    {
      name: "最大值",
      value: "max",
    },
    {
      name: "最小值",
      value: "min",
    },
  ];
  let date = [
    {
      name: "最大值",
      value: "max",
    },
    {
      name: "最小值",
      value: "min",
    },
  ];
  switch (props.item.fieldType) {
    case MODEL_COLUMN_TYPE.number:
      return basic.concat(num);
    case MODEL_COLUMN_TYPE.date:
      return basic.concat(date);
    default:
      return basic;
  }
});
</script>

<style scoped lang="scss"></style>
